import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { OracleServiceCloudLinkedService } from 'app/model/linkedservice/oracle-service-cloud.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleServiceCloudLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                host: '*',
                username: '*',
                password: 'secret',
                useEncryptedEndpoints: '*',
                useHostVerification: '*',
                usePeerVerification: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class OracleServiceCloudLinkedServiceAdapter extends LinkedServiceAdapter<OracleServiceCloudLinkedService> {
    protected modelConstructor(): new () => OracleServiceCloudLinkedService {
        return OracleServiceCloudLinkedService;
    }

    protected model(): IModel {
        return OracleServiceCloudLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: OracleServiceCloudLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.OracleServiceCloudLinkedService;
        properties.type = Metamodel.modelFor(OracleServiceCloudLinkedService).name;

        properties.typeProperties = {
            host: linkedService.host,
            username: linkedService.username,
            password: passwordOrAKVtoSecretBase(linkedService.password, this.context),
            useEncryptedEndpoints: linkedService.useEncryptedEndpoints,
            useHostVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.useHostVerification : undefined,
            usePeerVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.usePeerVerification : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: OracleServiceCloudLinkedService): Promise<OracleServiceCloudLinkedService> {
        const properties = linkedServiceResource.properties as Model.OracleServiceCloudLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.OracleServiceCloudLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.host = typeProperties.host;
        linkedService.username = typeProperties.username;
        linkedService.password = secretBaseToPasswordOrAKV(typeProperties.password, true, this.context);
        linkedService.useEncryptedEndpoints = typeProperties.useEncryptedEndpoints;
        linkedService.useHostVerification = typeProperties.useHostVerification;
        linkedService.usePeerVerification = typeProperties.usePeerVerification;

        return linkedService;
    }
}
